import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPage/getError'
import useLastHolderFields from './useLastHolderFields'
import PropertyDate from './PropertyDate'

const LastHolderFields = () => {
  const { t, errors, isEditable, lastHolderName, lastHolderCf, hidden, updateAddress } = useLastHolderFields()

  if (hidden) return null

  return (
    <>
      <SDFormControl error={getError('lastHolderName', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.last_holder_fields.name')}
          disabled={isEditable === false}
          currentValue={lastHolderName ?? ''}
          onBlur={(value: string | null) => updateAddress({ lastHolderName: value ?? '' })}
          error={getError('lastHolderName', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl error={getError('lastHolderCf', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.last_holder_fields.codice_fiscale')}
          disabled={isEditable === false}
          currentValue={lastHolderCf ?? ''}
          onBlur={(value: string | null) => updateAddress({ lastHolderCf: value ?? '' })}
          error={getError('lastHolderCf', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <PropertyDate />
    </>
  )
}

export default LastHolderFields
